import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { MdClear } from "react-icons/md";
import './NuevoPersonal.css';
import UsuarioService from '../../services/usuario.service';
import CadenaService from '../../services/cadena.service';
import EstablecimientoService from '../../services/establecimiento.service';
import EmpleadoService from '../../services/empleado.service';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import * as Constants from '../../constants';
import { AuthenticationService } from '../../services/authentication.service';
import { useEstablishment } from '../../Context/EstablishmentContext';

const PopUpEmpleado = (props) => {

	const { establecimiento } = useEstablishment();
	const [listaTiposUsuario, setListaTiposUsuario] = useState([])
	const [selectedTiposUsuario, setSelectedTiposUsuario] = useState(null);
	
	const [listaCadenas, setListaCadenas] = useState([])
	const [selectedCadena, setSelectedCadena] = useState(null);
	const [isSelectCadenaVisible, setIsSelectCadenaVisible] = useState(false);
	
	const [listaEstablecimientos, setListaEstablecimientos] = useState([]);
	const [selectedEstablecimiento, setSelectedEstablecimiento] = useState(null);
	const [isSelectEstablecimientoVisible, setIsSelectEstablecimientoVisible] = useState(false);
	
	const [listaTiposEmpleado, setListaTiposEmpleado] = useState([])
	const [selectedTipoEmpleado, setSelectedTipoEmpleado] = useState(null);
	const [isSelectTipoEmpleadoVisible, setIsSelectTipoEmpleadoVisible] = useState(false);

	const [selectedUsuario, setSelectedUsuario] = useState(null);

	const [nombre, setNombre] = useState('')
	const [apellidos, setApellidos] = useState('')
	const [email, setEmail] = useState('')
	const [activo, setActivo] = useState('')
	const [telefono, setTelefono] = useState('')
	const [nif, setNif] = useState('')
	const [password, setPassword] = useState('')

	const [nombreError, setNombreError] = useState('')
	const [apellidosError, setApellidosError] = useState('')
	const [emailError, setEmailError] = useState('')
	const [telefonoError, setTelefonoError] = useState('')
	const [nifError, setNifError] = useState('')
	const [passwordError, setPasswordError] = useState('')
	const [tipoUsuarioError, setTipoUsuarioError] = useState(null)
	const [tipoEmpleadoError, setTipoEmpleadoError] = useState(null)
	const authenticationService = new AuthenticationService();
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;
	const [t] = useTranslation("global");

	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {

		obtenerListaTipoUsuarios();
		obtenerListaCadenas();
		if(userRol == Constants.ROLE_USUARIO_ADMIN_CADENA) {
			obtenerListaEstablecimientosByCadena(authenticationService.getAuthenticationSession().user.cadena.id);
		} else {
			obtenerListaEstablecimientos();
		}
		
		
		obtenerListaTipoEmpleados();

		setSelectedUsuario(props.selectedUsuario);

		if (props.selectedUsuario != null) {
			
			// Modo edicion
			setNombre(props.selectedUsuario.nombre);
			setApellidos(props.selectedUsuario.apellidos);
			setTelefono(props.selectedUsuario.telefono);
			setEmail(props.selectedUsuario.email);
			setActivo(props.selectedUsuario.activo);
			setNif(props.selectedUsuario.nif);
		}

	}, []);

	function handleLogin(e) {
		e.preventDefault()
		
		// Code to handle login goes here
		props.toggle()
	}
	
	const obtenerListaTipoUsuarios = async () => {
		await UsuarioService.getTiposUsuarioByUserRole(userRol)
			.then(response => response.json())
			.then(data => setListaTiposUsuario(data));
		
	}
	
	const obtenerListaCadenas = async () => {
		await CadenaService.getCadenas()
			.then(response => response.json())
			.then(data => {
				setListaCadenas(data);
				setSelectedCadena(data[0]);
			});
	}
	
	const obtenerListaEstablecimientos = async () => {
		await EstablecimientoService.getEstablecimientos()
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setSelectedEstablecimiento(data[0]);
			});
	}
	
	const obtenerListaEstablecimientosByCadena = async (cadena) => {
		await EstablecimientoService.getEstablecimientosByParams('', 1, cadena)
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setSelectedEstablecimiento(data[0]);
			});
	}

	const obtenerListaTipoEmpleados = async () => {
		await EmpleadoService.getTiposEmpleado()
			.then(response => response.json())
			.then(data => {
				setListaTiposEmpleado(data);
				setSelectedTipoEmpleado(data[0]);	
			});
	}

	function validateForm(usuario) {

		// Set initial error values to empty  
		setNombreError('')
		setApellidosError('')
		setTipoUsuarioError(null)
		setTipoEmpleadoError(null)
		setEmailError('')
		setTelefonoError('')
		setNifError('')
		setPasswordError('')

		if (usuario.nombre === '') {
			setNombreError(t('app.error.campoObligatorio'))
			return;
		}

		if (usuario.apellidos === '') {
			setApellidosError(t('app.error.campoObligatorio'))
			return false;
		}

		if (usuario.email === '') {
			setEmailError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (!checkEmailFormat(usuario.email)) {
    		setEmailError(t('app.error.login.emailFormat'))
    		return
  		}

		if (usuario.telefono === '') {
			setTelefonoError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (usuario.nif === '') {
			setNifError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (usuario.idTipo === null) {
			setTipoUsuarioError(t('app.error.campoObligatorio'))
			return;
		}else{
			if (usuario.idTipo.id === 3 && usuario.tipoEmpleado.id === 0) {
				setTipoEmpleadoError(t('app.error.campoObligatorio'))
			return;
		}
		}
		if (usuario.id === null) {
			if (usuario.password === '') {
				setPasswordError(t('app.error.campoObligatorio'))
				return;
			}
		}

		if (usuario.id != null) {
			updateUsuario(usuario);
		} else {
			insertUsuario(usuario);
		}
	}
	
	function checkEmailFormat(email) {
	  const isValidEmail = Constants.emailRegex;
	  
	  if (isValidEmail.test(email)) {
		  return true;
	  } else {
		  return false;
	  }
  	}

	const guardarUsuario = async () => {

		if (selectedUsuario != null) {
			editarUsuario(selectedUsuario);
		} else {
			crearUsuario();
		}

	}

	const crearUsuario = async () => {

		const usuario = {
			nombre: nombre,
			idTipo: selectedTiposUsuario,
			apellidos: apellidos,
			email: email,
			telefono: telefono,
			nif: nif,
			password: password,
			cadena: selectedCadena,
			establecimiento: (userRol != Constants.ROLE_USUARIO_GESTOR) ? selectedEstablecimiento : establecimiento,
			tipoEmpleado: selectedTipoEmpleado
		};
		
		validateForm(usuario);

	}


	const editarUsuario = async (selectedUsuario) => {

		const usuario = {
			id: selectedUsuario.id,
			idTipo: selectedUsuario.idTipo,
			nombre: nombre,
			apellidos: apellidos,
			email: email,
			telefono: telefono,
			activo: activo,
			nif: nif,
			password : password
		};

		validateForm(usuario);
	}

	const insertUsuario = async (usuario) => {
		await UsuarioService.crearUsuario(usuario)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					props.limpiarFiltros();
					//props.loadUsuarios();
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const updateUsuario = async (usuario) => {
		await UsuarioService.actualizarUsuario(usuario)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
//					if(props.selectedTipo != null || props.activo != null){
//						props.loadEmpleadosByParams(props.selectedEstablecimiento, props.activo, '' , props.selectedTipo)
//					}else{
//						props.limpiarFiltros();
					props.limpiarFiltros();
						//props.loadUsuarios();
//					}
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const cancelarUsuario = () => {

		// Close popup
		props.toggle();
	}
	
	const onChangeTipoUsuario = (selectedValue) => {
		setSelectedTiposUsuario(selectedValue);
		
		setIsSelectEstablecimientoVisible((selectedValue.id === Constants.ROLE_USUARIO_GESTOR) || (selectedValue.id === Constants.ROLE_USUARIO_TRABAJADOR));
		setIsSelectCadenaVisible(selectedValue.id === Constants.ROLE_USUARIO_ADMIN_CADENA);
		setIsSelectTipoEmpleadoVisible(selectedValue.id === Constants.ROLE_USUARIO_TRABAJADOR);
	};
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Habitaciones del PopUp
	const getOptionValueTipoUsuario = option => option.id;
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Cadenas del PopUp
	const getOptionValueCadena = option => option.id;
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Establecimientos del PopUp
	const getOptionValueEstablecimientos = option => option.id;
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Tipos de Empleado del PopUp
	const getOptionValueTipoEmpleado = option => option.id;

	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					{selectedUsuario != null ? <h1 className={"popup-Title"}>{t("app.usuario.edicionUsuario")}</h1> : <h1 className={"popup-Title"}>{t("app.usuario.nuevoUsuario")}</h1>}
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>
				<div className="popup-Content">
					<form onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.nombre")} type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
								<label className="errorLabel">{nombreError}</label>
							</div>
							
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.apellidos")} type="text" value={apellidos} onChange={e => setApellidos(e.target.value)} />
								<label className="errorLabel">{apellidosError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.email")} type="text" value={email} onChange={e => setEmail(e.target.value)} />
								<label className="errorLabel">{emailError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.telefono")} type="text" value={telefono} onChange={e => setTelefono(e.target.value)} />
								<label className="errorLabel">{telefonoError}</label>
							</div>
							
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.nif")} type="text" value={nif} onChange={e => setNif(e.target.value)} />
								<label className="errorLabel">{nifError}</label>
							</div>
							
							{selectedUsuario == null ? (
								<div className={'inputAndSelectContainerPopup'}>
									<Select
										className="selectPopupStyle"
										placeholder={t("app.label.seleccionarTipoUsuario")}
										value={selectedTiposUsuario}
										onChange={onChangeTipoUsuario}
										options={listaTiposUsuario}
										isSearchable={false}
										formatOptionLabel={tipo => (
											<div>
												<span>{tipo.nombre}</span>
											</div>
										)}
										styles={colorFiltros}
										getOptionValue={getOptionValueTipoUsuario}
									/>
									<label className="errorLabel">{tipoUsuarioError}</label>
								</div>
							) : null}
							
							{isSelectCadenaVisible && (
								<div className={'inputAndSelectContainerPopup'}>
									<Select
										className="selectPopupStyle"
										value={selectedCadena}
										onChange={setSelectedCadena}
										options={listaCadenas}
										isSearchable={false}
										formatOptionLabel={cadena => (
											<div>
												<span>{cadena.nombre}</span>
											</div>
										)}
										styles={colorFiltros}
										getOptionValue={getOptionValueCadena}
									/>
								</div>
							)}
							
							{(isSelectEstablecimientoVisible && userRol != Constants.ROLE_USUARIO_GESTOR) && (
								<div className={'inputAndSelectContainerPopup'}>
									<Select
										className="selectPopupStyle"
										value={selectedEstablecimiento}
										onChange={setSelectedEstablecimiento}
										options={listaEstablecimientos}
										isSearchable={false}
										formatOptionLabel={est => (
											<div>
												<span>{est.nombre}</span>
											</div>
										)}
										styles={colorFiltros}
										getOptionValue={getOptionValueEstablecimientos}
									/>
								</div>
							)}
							
							{isSelectTipoEmpleadoVisible && (
								<div className={'inputAndSelectContainerPopup'}>
									<Select
										className="selectPopupStyle"
										value={selectedTipoEmpleado}
										onChange={setSelectedTipoEmpleado}
										options={listaTiposEmpleado}
										isSearchable={false}
										formatOptionLabel={tipo => (
											<div>
												<span>{tipo.nombre}</span>
											</div>
										)}
										styles={colorFiltros}
										getOptionValue={getOptionValueTipoEmpleado}
									/>
									<label className="errorLabel">{tipoEmpleadoError}</label>
								</div>
								
							)}
							
							<div className={'inputAndSelectContainerPopup'}>
									<input placeholder={t("app.popup.label.password")} type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password"/>
									<label className="errorLabel">{passwordError}</label>
								</div>

							{selectedUsuario != null ? (
								<div className={'checkboxContainerEmpleado'}>
									<label>{t("app.popup.label.activo")}</label>
									<input type='checkbox' id='checkboxActivo' checked={activo} onChange={e => setActivo(e.target.checked)} />
								</div>
							) : null}
							
						</div>
						<div className="popup-div-buttons">
							<button type="button" className="btn-general-colorPink" onClick={cancelarUsuario}>{t("app.label.cancelar")}</button>
							<button type="button" className="btn-general" onClick={guardarUsuario}>{t("app.label.guardar")}</button>
							<Toaster />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpEmpleado